/** Whether the viewer may use the moderation list. The server decides; this only hides the tab. */
export function isFeedbackStaff(user: { system_role: string }): boolean {
  return user.system_role === 'moderator' || user.system_role === 'admin';
}
